import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/lib';

type EmailSendingDomainsErrorCardProps = {
  onRetry: () => void;
};

export const EmailSendingDomainsErrorCard: FC<EmailSendingDomainsErrorCardProps> = ({ onRetry }) => {
  const { t } = useTranslation('campaign');

  return (
    <section className='bg-surface rounded-3xl border border-secondary-border p-8 shadow-sm md:p-10'>
      <div className='flex flex-col items-center rounded-2xl border border-secondary-border bg-white px-6 py-14 text-center'>
        <h2 className='text-xl font-bold text-slate-900'>{t('emailWorkspace.domains.loadFailedTitle')}</h2>
        <p className='text-secondary-600 mt-2 max-w-lg text-sm leading-relaxed'>{t('emailWorkspace.domains.loadFailed')}</p>
        <Button intent='primary' className='mt-6' onClick={onRetry} text={t('emailWorkspace.templates.tryAgain')} />
      </div>
    </section>
  );
};
